<template>
  <div>
    <b-form @submit.prevent="updateGeofence" @mouseover="geofence.extraData.weight = 4" @mouseout="geofence.extraData.weight = 2">
      <b-form-row>
        <b-form-group class="col-12">
          <label :for="'geofence-name-' + index" v-translate>Name <small class="text-danger">(required)</small></label>
          <b-form-input :id="'geofence-name-' + index" v-model="geofence.name" type="text" :style="isPrincipal ? 'font-size: 1.5rem' : ''" required />
        </b-form-group>
        <b-form-group class="col-12">
          <label :for="'geofence-type-' + index" v-translate>Type <small class="text-danger">(required)</small></label>
          <b-form-select :id="'geofence-type-' + index" v-model="geofence.geo_type_id" :options="geoTypesSelectComputed" v-if="geoTypesSelect.length > 0" required>
            <template #first>
              <option :value="null" v-translate>Select the Type</option>
            </template>
          </b-form-select>
        </b-form-group>
        <b-form-group class="col-12" v-if="!isPrincipal">
          <b-form-checkbox v-model="fullForm"><translate>Optional Data</translate></b-form-checkbox>
        </b-form-group>
        <b-collapse :visible="isPrincipal || (!isPrincipal && fullForm)" class="col-12">
          <b-form-group>
            <label :for="'geofence-reference-location-' + index" v-translate>Reference Location</label>
            <b-form-input :id="'geofence-reference-location-' + index" v-model="geofence.reference_location" type="text" />
          </b-form-group>
          <b-form-group>
            <label :for="'geofence-external-id-' + index" v-translate>External ID</label>
            <b-form-input :id="'geofence-external-id-' + index" v-model="geofence.external_id" type="text" />
          </b-form-group>
          <b-form-group>
            <label :for="'geofence-address-' + index" v-translate>Address</label>
            <b-form-input :id="'geofence-address-' + index" v-model="geofence.address" type="text" />
          </b-form-group>
          <b-form-group>
            <label :for="'geofence-city-' + index" v-translate>City</label>
            <b-form-input :id="'geofence-city-' + index" v-model="geofence.city" type="text" />
          </b-form-group>
          <b-form-group>
            <label :for="'geofence-zip-' + index" v-translate>Zip Code</label>
            <b-form-input :id="'geofence-zip-' + index" v-model="geofence.zip" type="text" />
          </b-form-group>
          <b-form-group>
            <label :for="'geofence-state-' + index" v-translate>State/Province</label>
            <b-form-input :id="'geofence-state-' + index" v-model="geofence.state" type="text" />
          </b-form-group>
          <b-form-group>
            <label :for="'geofence-country-' + index" v-translate>Country</label>
            <b-form-input :id="'geofence-country-' + index" v-model="geofence.country" type="text" />
          </b-form-group>
          <b-form-group>
            <label :for="'geofence-timezone-' + index" v-translate>Standard Time Zone</label>
            <b-form-input :id="'geofence-timezone-' + index" v-model="geofence.timezone" type="text" />
          </b-form-group>
          <div v-if="isTopLevel">
            <b-form-group>
              <label :for="'geofence-commodity-' + index" v-translate>Commodity</label>
              <commodity-autocomplete ref="commodityAutocomplete" :pre-query="commodityPreQuery" @selected="setCommodity" />
            </b-form-group>
            <b-form-group>
              <label :for="'geofence-commodity-variety-' + index" v-translate>Variety</label>
              <commodity-variety-autocomplete ref="commodityVarietyAutocomplete" :pre-query="commodityVarietyPreQuery" @selected="setCommodityVariety" />
            </b-form-group>
          </div>
        </b-collapse>
        <b-form-group class="col-12">
          <b-button size="sm" :variant="geofenceHasChanges ? 'secondary' : 'dark'" :disabled="!geofenceHasChanges || !geofence.coordinates || geofence.coordinates.length === 0" type="submit" :id="isPrincipal ? 'principal-submit' : ''">
            <b-spinner small v-if="updating"></b-spinner>
            <translate>Save Changes</translate>
          </b-button>
          <b-button size="sm" @click.prevent="emitCenter" :title="$gettext('Center in Map')" :disabled="!geofence.coordinates || geofence.coordinates.length === 0" v-b-tooltip.hover><font-awesome-icon icon="crosshairs" /></b-button>
          <b-button size="sm" variant="dark" @click="geofence.extraData.visible = !geofence.extraData.visible" :title="!geofence.extraData.visible ? $gettext('Show Element') : $gettext('Hide Element')" :disabled="!geofence.coordinates || geofence.coordinates.length === 0" v-b-tooltip.hover>
            <font-awesome-icon :icon="['far', 'eye']" v-show="!geofence.extraData.visible" />
            <font-awesome-icon :icon="['far', 'eye-slash']" v-show="geofence.extraData.visible" />
          </b-button>
          <b-button size="sm" variant="danger" @click="removeGeofence" :title="$gettext('Remove Relation')" v-b-tooltip.hover v-if="!isPrincipal">
            <font-awesome-icon icon="unlink" />
          </b-button>
          <b-button size="sm" variant="danger" @click="deleteGeoFence" :title="$gettext('Completely DELETE this GeoFence and its Relations')" v-b-tooltip.hover v-else>
            <font-awesome-icon icon="trash-alt" />
          </b-button>
        </b-form-group>
      </b-form-row>
    </b-form>
  </div>
</template>

<script>
import {
  GeofenceService
} from '@/services/api'
import CommodityAutocomplete from '@/components/Autocompletes/CommodityAutocomplete'
import CommodityVarietyAutocomplete from '@/components/Autocompletes/CommodityVarietyAutocomplete'

export default {
  name: 'GeofenceForm',
  components: {
    CommodityAutocomplete,
    CommodityVarietyAutocomplete
  },
  props: {
    geofence: {
      type: Object,
      default: () => {},
      required: true
    },
    index: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      geoTypesSelect: [],
      hash: null,
      updating: false,
      fullForm: false
    }
  },
  computed: {
    isPrincipal() {
      return this.$route.params.id + '' === this.geofence.id + ''
    },
    isTopLevel() {
      return this.geofence.id ? this.geofence.geo_type.level === 0 : this.geoTypesSelect.findIndex(x => x.value === this.geofence.geo_type_id) !== -1 && this.geoTypesSelect.find(x => x.value === this.geofence.geo_type_id).level === 0
    },
    geoTypesSelectComputed() {
      return this.geofence.id ? this.geoTypesSelect.filter(x => x.type === this.geofence.originalFence.type.toLowerCase() && ((this.isPrincipal) || (!this.isPrincipal && x.level === 1))) : this.geoTypesSelect.filter(x => x.type === 'polygon' && ((this.isPrincipal && x.level === 0) || (!this.isPrincipal && x.level === 1)))
    },
    geofenceHasChanges() {
      let geofenceHash = Object.assign({}, this.geofence)
      delete geofenceHash.extraData
      return JSON.stringify(geofenceHash) !== this.hash
    },
    commodityPreQuery() {
      return this.geofence.meta?.commodity ? (this.geofence.meta.commodity.external_id || this.geofence.meta.commodity.reference) : null
    },
    commodityVarietyPreQuery() {
      return this.geofence.meta?.commodity_variety ? (this.geofence.meta.commodity_variety.external_id || this.geofence.meta.commodity_variety.reference) : ''
    }
  },
  created () {
    this.geoTypesSelect = this.geoTypes.map(x => {
      return {
        text: this.toTitleCase(x.name),
        value: x.id,
        type: x.type,
        level: x.level
      }
    })
  },
  mounted () {
    let geofenceHash = Object.assign({}, this.geofence)
    delete geofenceHash.extraData
    this.hash = JSON.stringify(Object.assign({}, geofenceHash))
    if (this.geofence.id && this.geofence.adding) {
      GeofenceService.addGeofence(this.geofence.parent, this.geofence.id)
        .then(() => {
          this.$nextTick(() => {
            this.$emit('updated', true)
            let geofenceHash = Object.assign({}, this.geofence)
            delete geofenceHash.extraData
            this.hash = JSON.stringify(Object.assign({}, geofenceHash))
          })
        })
    }
    if (this.isTopLevel) {
      if (this.geofence.meta?.variety) {
        this.fixBrokenVarietyData(this.geofence.meta.variety)
      } else if (this.geofence.meta?.commodity_id) {
        this.setCommodity(this.geofence.meta.commodity)
        this.$nextTick(() => {
          this.$refs.commodityAutocomplete.searchQuery = this.commodityPreQuery
        })
        if (this.geofence.meta?.commodity_variety) {
          this.setCommodityVariety(this.geofence.meta.commodity_variety)
          this.$nextTick(() => {
            this.$refs.commodityVarietyAutocomplete.searchQuery = this.commodityVarietyPreQuery
          })
        }
      }
    }
  },
  methods: {
    fixBrokenVarietyData(variety) {
      let params = {
        includes: ['commodity_varieties'],
        sort: [
          {
            key: 'external_id',
            direction: 'asc'
          },
          {
            key: 'id',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            or: true,
            filters: [
              ['commodity_varieties.external_id', 'ct', variety.trim()]
            ]
          }
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'commodities', {params})
        .then(response => {
          let meta = {
            commodity: response.body.data[0],
            commodity_id: response.body.data[0].id,
            commodity_variety: response.body.data[0].commodity_varieties.findIndex(x => x.external_id === variety.trim()) !== -1 ? response.body.data[0].commodity_varieties.find(x => x.external_id === variety.trim()) : null,
            commodity_variety_id: response.body.data[0].commodity_varieties.findIndex(x => x.external_id === variety.trim()) !== -1 ? response.body.data[0].commodity_varieties.find(x => x.external_id === variety.trim()).id : null
          }
          this.$store.commit('setCommodityVarieties', response.body.data[0].commodity_varieties)
          delete this.geofence.meta.variety
          this.geofence.meta = {...this.geofence.meta, ...meta}
        })
    },
    setCommodity(result) {
      if (!this.geofence.meta) {
        this.geofence.meta = {}
      }
      this.geofence.meta.commodity = result
      this.geofence.meta.commodity_id = result.id
      this.geofence.meta.commodity_variety_id = null
      console.log('setting Commodity Varities on SELECT')
      this.$store.commit('setCommodityVarieties', result.commodity_varieties)
    },
    setCommodityVariety(result) {
      this.geofence.meta.commodity_variety_id = result.id
      this.geofence.meta.commodity_variety = result
    },
    updateGeofence() {
      this.updating = true
      console.log(this.geofence.id, this.geofence)
      if (this.geofence.id) {
        GeofenceService.update(this.geofence.id, this.geofence)
          .then(() => {
            this.$nextTick(() => {
              this.$emit('updated', true)
              this.updating = false
            })
          })
      } else {
        GeofenceService.create(this.geofence)
          .then(response => {
            if (this.geofence.parent) {
              GeofenceService.addGeofence(this.geofence.parent, response.body.id)
                .then(() => {
                  this.$nextTick(() => {
                    this.$emit('updated', true)
                    this.updating = false
                    this.hash = JSON.stringify(Object.assign({}, this.geofence))
                  })
                })
            } else {
              this.$nextTick(() => {
                this.$emit('updated', true)
                this.updating = false
                window.location.href = this.$router.resolve({name: 'GeofencesEdit', params: {id: response.body.id}}).href
              })
            }
          })
      }
    },
    removeGeofence() {
      if (confirm(this.$gettext('Are you sure you want to REMOVE THIS RELATION?'))) {
        if (this.geofence.id) {
          GeofenceService.removeGeofence(this.geofence.parent, this.geofence.id)
            .then(() => {
              this.$nextTick(() => {
                this.$emit('updated', true)
              })
            })
        } else {
          this.$emit('remove', true)
        }
      }
    },
    deleteGeoFence() {
      if (this.geofence.id) {
        if (confirm(this.$gettext('Are you sure you want to COMPLETELY DELETE THIS GEOFENCE AND ITS RELATIONS?\nWARNING: THIS ACTION CANNOT BE UNDONE!'))) {
          GeofenceService.delete(this.geofence.id)
            .then(() => {
              this.$nextTick(() => {
                this.$router.back()
              })
            })
        }
      }
    },
    emitCenter($event) {
      this.$emit('center', 'fence', this.geofence.fence)
    },
    getCenter(coordinates) {
      return coordinates.reduce(function (x, y) {
        return [x[0] + y[0] / coordinates.length, x[1] + y[1] / coordinates.length]
      }, [0, 0])
    }
  }
}
</script>
